import { AxiosError } from "axios";
import { useMutation, useQueryClient } from "react-query";
import { api } from "services/api";
import { AddSupportAgentData } from "types/SupportAgent";
import { axiosError, axiosSuccess, handleRequestError, handleRequestSuccess } from "utils/Request";

async function addSupportAgent(data: AddSupportAgentData) {
  const { data: response } = await api.post('/support/agents', data).then(axiosSuccess).catch(axiosError);
  return response;
}

export function useAddSupportAgent() {
  const queryClient = useQueryClient();

  return useMutation((data: AddSupportAgentData) => addSupportAgent(data), {
    onSuccess: () => {
      handleRequestSuccess('Agente adicionado ao rodízio com sucesso!');
      queryClient.invalidateQueries('support-agents');
      queryClient.invalidateQueries('support-stats');
    },
    onError: (error: AxiosError) => {
      handleRequestError(error, 'Erro ao adicionar agente. Tente novamente.');
    },
  });
}
